<c-container fluid>
  <c-row class="justify-content-center">
    <c-col lg="6" md="8" sm="12">
      <c-card class="delete-account-card">
        <c-card-header>
          <div class="d-flex align-items-center">
            <button
              cButton
              color="secondary"
              variant="ghost"
              size="sm"
              class="me-2"
              (click)="navigateBack()"
              [disabled]="loading() || step() === 'success'"
            >
              <svg cIcon name="cilArrowLeft" size="lg"></svg>
            </button>
            <strong>{{ 'delete_account.title' | translate }}</strong>
          </div>
        </c-card-header>

        <c-card-body>
          <!-- Error Alert -->
          @if (error(); as err) {
            <c-alert color="danger" [dismissible]="true" (visibleChange)="error.set(null)">
              {{ err }}
            </c-alert>
          }

          <!-- Success Alert -->
          @if (success(); as msg) {
            <c-alert color="success">
              {{ msg }}
            </c-alert>
          }

          <!-- Step 1: Initial Warning -->
          @if (step() === 'initial') {
            <div class="step-initial">
              <div class="warning-box mb-4">
                <div class="warning-icon">
                  <svg cIcon name="cilWarning" size="xl"></svg>
                </div>
                <h5 class="warning-title">{{ 'delete_account.warning_title' | translate }}</h5>
                <p class="warning-message">{{ 'delete_account.warning_message' | translate }}</p>
              </div>

              <div class="steps-info mb-4">
                <h6>{{ 'delete_account.confirm_heading' | translate }}</h6>
                <ol>
                  <li>{{ 'delete_account.step1' | translate }}</li>
                  <li>{{ 'delete_account.step2' | translate }}</li>
                </ol>
              </div>

              <div class="d-flex justify-content-between">
                <button
                  cButton
                  color="secondary"
                  (click)="navigateBack()"
                  [disabled]="loading()"
                >
                  {{ 'delete_account.back_to_profile' | translate }}
                </button>

                <button
                  cButton
                  color="danger"
                  (click)="requestDeletionCode()"
                  [disabled]="loading()"
                >
                  @if (loading()) {
                    <c-spinner size="sm" class="me-2"></c-spinner>
                  }
                  {{ loading() ? ('delete_account.sending' | translate) : ('delete_account.request_code_button' | translate) }}
                </button>
              </div>
            </div>
          }

          <!-- Step 2: Enter Confirmation Code -->
          @if (step() === 'awaiting_code') {
            <div class="step-confirm">
              <div class="code-info mb-4">
                <p class="text-muted">{{ 'delete_account.code_sent' | translate }}</p>

                @if (timeRemaining() && !isCodeExpired()) {
                  <div class="expiration-timer">
                    <span class="label">{{ 'delete_account.code_expires' | translate }}</span>
                    <span class="time" [class.expiring]="timeRemaining().startsWith('0:')">
                      {{ timeRemaining() }}
                    </span>
                  </div>
                }

                @if (isCodeExpired()) {
                  <c-alert color="warning">
                    {{ 'delete_account.error_expired_code' | translate }}
                  </c-alert>
                }
              </div>

              <div class="code-input-wrapper mb-4">
                <input
                  cFormControl
                  type="text"
                  [value]="confirmationCode()"
                  (input)="confirmationCode.set($event.target.value.trim())"
                  [placeholder]="'delete_account.enter_code_placeholder' | translate"
                  maxlength="6"
                  pattern="[0-9]*"
                  inputmode="numeric"
                  class="code-input text-center"
                  [disabled]="loading() || isCodeExpired()"
                />
              </div>

              <div class="d-flex justify-content-between flex-wrap gap-2">
                <button
                  cButton
                  color="secondary"
                  (click)="cancelDeletion()"
                  [disabled]="loading()"
                >
                  {{ 'delete_account.cancel_button' | translate }}
                </button>

                <button
                  cButton
                  color="danger"
                  (click)="confirmDeletion()"
                  [disabled]="loading() || confirmationCode().length !== 6 || isCodeExpired()"
                >
                  @if (loading()) {
                    <c-spinner size="sm" class="me-2"></c-spinner>
                  }
                  {{ loading() ? ('delete_account.deleting' | translate) : ('delete_account.confirm_delete_button' | translate) }}
                </button>
              </div>

              @if (isCodeExpired()) {
                <div class="mt-3 text-center">
                  <button
                    cButton
                    color="primary"
                    variant="outline"
                    (click)="requestDeletionCode()"
                    [disabled]="loading()"
                  >
                    {{ 'delete_account.request_code_button' | translate }}
                  </button>
                </div>
              }
            </div>
          }

          <!-- Step 3: Success -->
          @if (step() === 'success') {
            <div class="step-success text-center">
              <div class="success-icon mb-3">
                <svg cIcon name="cilCheckCircle" size="3xl" class="text-success"></svg>
              </div>
              <h5 class="mb-3">{{ 'delete_account.success_message' | translate }}</h5>
              <p class="text-muted">Redirecting to login...</p>
              <c-spinner color="primary"></c-spinner>
            </div>
          }
        </c-card-body>
      </c-card>
    </c-col>
  </c-row>
</c-container>